import { useTranslation } from 'react-i18next'

import { Badge } from '@enechain/ecloud-designsystem'

import type { EnumBadgeSpec } from '~/components/common/EnumStatusBadge'
import {
  type BidWithdrawState,
  withdrawStateHintKey,
} from '~/pages/SpotBidding/models/bidWithdrawState'

/** 取下の進み具合 → 併記するチップ。 取下失敗は取下処理中より強い警告。 */
const WITHDRAW_STATE_BADGE: Record<BidWithdrawState, EnumBadgeSpec> = {
  withdrawing: {
    status: 'warning',
    labelKey: 'page:biddingSpot.withdrawState.pending',
  },
  withdrawFailed: {
    status: 'negative',
    labelKey: 'page:biddingSpot.withdrawState.failed',
  },
}

/**
 * 札・ブロック入札グループの取下の進み具合のチップ。 ステータスは変えず、 別軸として
 * ステータスの横に併記する (AC-BSP-057b。 時間前入札の取消処理中チップと同じ見せ方)。
 */
export const WithdrawStateBadge = ({
  state,
  isPastDeadline,
  marginLeft,
}: {
  state: BidWithdrawState
  isPastDeadline: boolean
  marginLeft?: number
}): React.ReactElement => {
  const { t } = useTranslation()
  const spec = WITHDRAW_STATE_BADGE[state]
  return (
    <Badge
      marginLeft={marginLeft}
      whiteSpace="nowrap"
      status={spec.status}
      title={t(withdrawStateHintKey(state, isPastDeadline))}
    >
      {t(spec.labelKey)}
    </Badge>
  )
}
